const DCMViewerLog = {
    info: message => console.info(message),
    warn: message => console.warn(message)
};

export { DCMViewerLog };
